/**
*time: 2021/8/13
*/
<template>
  <div class="listContent">
    <a-tabs defaultActiveKey="raw" :animated="false" @change="handleTabChange">
      <a-tab-pane key="raw" tab="原料">
        <a-form :form="form" class="headForm" labelAlign="left">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="原料">
                <a-select v-decorator="['rawSearchKey']" allowClear show-search placeholder="原料名称或代码"
                  :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                  @search="handleRawSearch" @select="handleRawSelect">
                  <template slot="notFoundContent">
                    <a-spin v-if="searchLoading" size="small" />
                    <span v-else>无匹配结果</span>
                  </template>
                  <a-select-option v-for="d in rawSearchList" :key="d.rawId">
                    {{ d.firstName }}<span style="color: red">{{ d.midName }}</span>{{ d.lastName }}({{ d.code }})
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="类目名称">
                <a-input v-decorator="['typeSearchKey']"
                  @pressEnter="getList({ current: 1, pageSize: pagination.pageSize })" placeholder="类目名称" />
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="选择日期">
                <a-range-picker v-decorator="['date']" class="search_content_class" :locale="locale" />
              </a-form-item>
            </a-col>
            <a-col :span="4" class="submitBtnBox">
              <a-button type="primary" class="btnMar" @click="getList({ current: 1, pageSize: pagination.pageSize })">
                查询
              </a-button>
              <a-button class="" @click="resetFields">
                清空
              </a-button>
            </a-col>
          </a-row>
        </a-form>
        <div class="content_class">
          <a-table ref="listRef" :scroll="{ y, x: 1000 }" class="tableBox" :columns="columns" :data-source="list"
            :pagination="pagination" :locale="locale" rowKey="id" :loading="loading">
            <template v-for="el in ['oldValue', 'newValue', 'diffValue']" :slot="el" slot-scope="text">
              <span :key="el">{{ text && (Number(text) || Number(text) === 0) ? Number(text).toFixed(3) : text }}</span>
            </template>
          </a-table>
        </div>
      </a-tab-pane>

      <a-tab-pane key="nutrition" tab="营养指标">
        <a-form :form="nutritionForm" class="headForm" labelAlign="left">
          <a-row :gutter="24">
            <a-col :span="6">
              <a-form-item label="原料">
                <a-select v-decorator="['rawSearchKey']" allowClear show-search placeholder="原料名称或代码"
                  :default-active-first-option="false" :show-arrow="false" :filter-option="false"
                  @search="handleRawSearch" @select="handleNutritionRawSelect">
                  <template slot="notFoundContent">
                    <a-spin v-if="searchLoading" size="small" />
                    <span v-else>无匹配结果</span>
                  </template>
                  <a-select-option v-for="d in rawSearchList" :key="d.rawId">
                    {{ d.firstName }}<span style="color: red">{{ d.midName }}</span>{{ d.lastName }}({{ d.code }})
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="营养指标">
                <a-select
                  v-decorator="['nutritionSearchKey']"
                  allowClear
                  show-search
                  placeholder="输入指标名称或代码"
                  :default-active-first-option="false"
                  :show-arrow="false"
                  :filter-option="false"
                  @search="handleNutritionSearch"
                  @select="handleNutritionSelect"
                >
                  <template slot="notFoundContent">
                    <a-spin v-if="nutritionSearchLoading" size="small" />
                    <span v-else>无匹配结果</span>
                  </template>
                  <a-select-option v-for="d in nutritionSearchList" :key="d.id">
                    {{ d.name }}({{ d.fullName }})
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col :span="6">
              <a-form-item label="选择日期">
                <a-range-picker v-decorator="['date']" class="search_content_class" :locale="locale" />
              </a-form-item>
            </a-col>
            <a-col :span="4" class="submitBtnBox">
              <a-button type="primary" class="btnMar"
                @click="getNutritionList({ current: 1, pageSize: nutritionPagination.pageSize })">
                查询
              </a-button>
              <a-button class="" @click="resetNutritionFields">
                清空
              </a-button>
            </a-col>
          </a-row>
        </a-form>
        <div class="content_class">
          <a-table ref="nutritionListRef" :scroll="{ y, x: 1000 }" class="tableBox" :columns="nutritionColumns"
            :data-source="nutritionList" :pagination="nutritionPagination" :locale="locale" rowKey="id"
            :loading="nutritionLoading">
            <template v-for="el in ['oldValue', 'newValue', 'diffValue']" :slot="el" slot-scope="text">
              <span :key="el">{{ formatDecimal(text) }}</span>
            </template>
          </a-table>
        </div>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
import moment from 'moment';
import _ from 'lodash';
const columns = [
  {
    title: '日期',
    dataIndex: 'createTime',
    align: 'center',
  },
  {
    title: '原料名称',
    dataIndex: 'rawName',
    align: 'center',
  },
  {
    title: '原料代码',
    dataIndex: 'rawCode',
    align: 'center',
  },
  {
    title: '类目名称',
    dataIndex: 'editItemName',
    align: 'center',
  },
  {
    title: '原值',
    dataIndex: 'oldValue',
    align: 'center',
    scopedSlots: { customRender: 'oldValue' },
  },
  {
    title: '新值',
    dataIndex: 'newValue',
    align: 'center',
    scopedSlots: { customRender: 'newValue' },
  },
  {
    title: '差异',
    dataIndex: 'diffValue',
    align: 'center',
    scopedSlots: { customRender: 'diffValue' },
  },
];

const nutritionColumns = [
  {
    title: '日期',
    dataIndex: 'updateTime',
    align: 'center',
  },
  {
    title: '原料名称',
    dataIndex: 'rawName',
    align: 'center',
  },
  {
    title: '原料代码',
    dataIndex: 'rawCode',
    align: 'center',
  },
  {
    title: '指标名称',
    dataIndex: 'nutritionName',
    align: 'center',
  },
  {
    title: '指标代码',
    dataIndex: 'nutritionCode',
    align: 'center',
  },
  {
    title: '原值',
    dataIndex: 'oldValue',
    align: 'center',
    scopedSlots: { customRender: 'oldValue' },
  },
  {
    title: '新值',
    dataIndex: 'newValue',
    align: 'center',
    scopedSlots: { customRender: 'newValue' },
  },
  {
    title: '差异',
    dataIndex: 'diffValue',
    align: 'center',
    scopedSlots: { customRender: 'diffValue' },
  },
  {
    title: '单位',
    dataIndex: 'convertUnitName',
    align: 'center',
    scopedSlots: { customRender: 'convertUnitName' },
  },
  {
    title: '数据源',
    dataIndex: 'dataSourceName',
    align: 'center',
    scopedSlots: { customRender: 'dataSourceName' },
  },
];

export default {
  data() {
    return {
      y: 500,
      form: this.$form.createForm(this, { name: 'OperationLog' }),
      nutritionForm: this.$form.createForm(this, { name: 'NutritionLog' }),
      locale,
      rawSearchList: [],
      searchLoading: false,
      handleRawSearch: null,
      activeTab: 'raw',
      pagination: {
        total: 0,
        pageSize: 20,
        current: 1,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.pagination.current = current;
          this.pagination.pageSize = pageSize;
          this.getList();
        },//选择页数
        onShowSizeChange: (current, pageSize) => {
          this.pagination.pageSize = pageSize;
          this.pagination.current = 1;
          this.getList({ current: 1, pageSize });
        } //每页多少条
      },
      nutritionPagination: {
        total: 0,
        pageSize: 20,
        current: 1,
        pageSizeOptions: ['10', '20', '30', '40', '50'],
        showSizeChanger: true,
        showTotal: (total) => `共${total}条记录`,
        onChange: (current, pageSize) => {
          this.nutritionPagination.current = current;
          this.nutritionPagination.pageSize = pageSize;
          this.getNutritionList();
        },
        onShowSizeChange: (current, pageSize) => {
          this.nutritionPagination.pageSize = pageSize;
          this.nutritionPagination.current = 1;
          this.getNutritionList({ current: 1, pageSize });
        }
      },
      columns,
      nutritionColumns,
      list: [],
      nutritionList: [],
      loading: false,
      nutritionLoading: false,
      nutritionSearchList: [],
      nutritionSearchLoading: false,
    };
  },
  created() {
    this.getList();
    this.handleRawSearch = _.debounce((keyword) => {
      if (keyword) {
        this.rawSearchList = [];
        this.searchLoading = true;
        let params = {
          factoryId: window.localStorage.getItem('factoryId'),
          current: 1,
          size: 20,
          name: keyword
        };
        this.$get('/nhf-app/factorystaffraw/myRawpage', params).then(res => {
          let { success, data } = res;
          if (success) {
            let { records } = data;
            records.map(el => {
              let nameArr = el.name.split(keyword);
              el.firstName = nameArr[0] || '';
              el.lastName = nameArr[1] || '';
              el.midName = keyword;
              return el;
            });
            this.rawSearchList = records || [];
          } else {
            this.rawSearchList = [];
          }
          this.searchLoading = false;
        }).catch(() => {
          this.rawSearchList = [];
          this.searchLoading = false;
        });
      } else {
        this.rawSearchList = [];
      }
    }, 300);
    // 新增营养指标搜索处理函数
    this.handleNutritionSearch = _.debounce((keyword) => {
      if (keyword) {
        this.nutritionSearchList = [];
        this.nutritionSearchLoading = true;
        let params = {
          factoryId: window.localStorage.getItem('factoryId'),
          current: 1,
          size: 20,
          searchKey: keyword
        };
        this.$get('/nhf-core-data/nutritiontarget/nutritionUserPage', params).then(res => {
          let { success, data } = res;
          if (success) {
            let { records } = data;
            this.nutritionSearchList = records || [];
          } else {
            this.nutritionSearchList = [];
          }
          this.nutritionSearchLoading = false;
        }).catch(() => {
          this.nutritionSearchList = [];
          this.nutritionSearchLoading = false;
        });
      } else {
        this.nutritionSearchList = [];
      }
    }, 300);
  },
  mounted() {
    this.y = this.$refs.listRef.$el.offsetHeight - 116;
  },
  methods: {
    resetFields() {
      this.form.resetFields();
    },
    resetNutritionFields() {
      this.nutritionForm.resetFields();
    },
    handleTabChange(key) {
      this.activeTab = key;
      if (key === 'raw') {
        this.getList();
      } else if (key === 'nutrition') {
        this.getNutritionList();
      }
    },
    formatDecimal(value) {
      if (value === undefined || value === null || value === '') {
        return '';
      }
      return Number(value).toFixed(3);
    },
    getList(pagination) {
      let { current, pageSize } = pagination || this.pagination;
      this.loading = true;

      this.form.validateFields((err, values) => {
        let { date, ...newValues } = values || {};
        let params = {
          query: {
            current,
            size: pageSize,
          },
          timeStart: date && date.length ? moment(date[0]).format('YYYY-MM-DD 00:00:00') : undefined,
          timeEnd: date && date.length ? moment(date[1]).format('YYYY-MM-DD 23:59:59') : undefined,
          rawId: newValues.rawSearchKey ? newValues.rawSearchKey : undefined,
          editItemName: newValues.typeSearchKey ? newValues.typeSearchKey : undefined,
          factoryId: window.localStorage.getItem('factoryId'),
          staffId: window.localStorage.getItem('staffId')
        };
        this.$post('/iot-log/nhfrawdatarecord/pageNhfRawDataRecordVO', params).then(res => {
          let { success, data } = res;
          if (success) {
            let { records, current = 1, total = 0 } = data;
            this.pagination.current = current;
            this.pagination.total = total;
            this.list = records || [];
          } else {
            this.$message.error('查询失败');
          }
          this.loading = false;
        }).catch(() => {
          this.loading = false;
        });
      });
    },
    handleNutritionSelect(value) {
      console.log(value);
      this.getNutritionList({ current: 1, pageSize: this.nutritionPagination.pageSize });
    },
    getNutritionList(pagination) {
      let { current, pageSize } = pagination || this.nutritionPagination;
      this.nutritionLoading = true;

      this.nutritionForm.validateFields((err, values) => {
        let { date, ...newValues } = values || {};
        let params = {
          "factoryId": window.localStorage.getItem('factoryId'),
          "staffId": window.localStorage.getItem('staffId'),
          "query": {
            "current": current,
            "size": pageSize
          },
          "rawId": newValues.rawSearchKey ? newValues.rawSearchKey : undefined,
          "nutritionId": newValues.nutritionSearchKey ? newValues.nutritionSearchKey : undefined,
          "timeEnd": date && date.length ? moment(date[1]).format('YYYY-MM-DD 23:59:59') : undefined,
          "timeStart": date && date.length ? moment(date[0]).format('YYYY-MM-DD 00:00:00') : undefined
        };
        this.$post('/iot-log/nhfnutritiondatarecord/pageNhfNutritionDataRecordVO', params).then(res => {
          let { success, data } = res;
          if (success) {
            let { records, current = 1, total = 0 } = data;
            this.nutritionPagination.current = current;
            this.nutritionPagination.total = total;
            this.nutritionList = records || [];
          } else {
            this.$message.error('查询失败');
          }
          this.nutritionLoading = false;
        }).catch(() => {
          this.nutritionLoading = false;
        });
      });
    },
    onChange() { },
    handleChange() { },
    addHandle() { },
    resetHandle() { },
    handleRawSelect(value) {
      console.log(value);
      this.getList({ current: 1, pageSize: this.pagination.pageSize });
    },
    handleNutritionRawSelect(value) {
      console.log(value);
      this.getNutritionList({ current: 1, pageSize: this.nutritionPagination.pageSize });
    },
  }
};
</script>
<style lang="scss" scoped>
.listContent {
  background-color: #fff;
  padding: 10px;

  ::v-deep(.ant-tabs-nav-container) {
    padding: 0px 20px;
  }

  .title_class {
    background-color: #fff;
    margin-bottom: 21px;
    border-radius: 5px;
    padding: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;

    .title_search_class {
      display: flex;
      flex-wrap: wrap;
      flex: 2;

      .search_change_class {
        display: flex;
        align-items: center;
        margin: 0 10px 10px 0;

        .text_class {
          width: 100px;
        }
      }
    }

    .title_btn_class {
      flex: 0.6;

      .search_class {
        margin-right: 10px;
      }
    }
  }

  .content_class {
    background-color: #fff;
    border-radius: 5px;
    // padding: 20px;
    height: calc(100% - 80px);
  }
}

.tableBox {
  padding: 0;
  height: calc(100vh - 250px);
}
</style>
